import styled from 'styled-components';

import { copyBaseStyles, copySizes } from '@/components/elements';
import { focusStyleDark } from '@/components/utils';
import Arrow from '@/icons/xsmall/Arrow-Thin-Right.svg';

import { Wrapper } from '../Wrapper';

export const StyledWrapper = styled(Wrapper)`
  max-width: var(--max-width-page);
  padding-top: var(--distance-static-l);
  padding-bottom: var(--distance-static-l);
`;

export const StyledList = styled.ol`
  display: flex;
  gap: var(--distance-static-3xs);
  margin: 0;
  padding: 0;
`;

export const StyledItem = styled.li`
  display: flex;
  gap: var(--distance-static-3xs);
  align-items: center;
  list-style: none;
  color: var(--color-text-dark-subdued);
`;

export const StyledLink = styled.a`
  position: relative;
  ${copyBaseStyles}
  ${copySizes.s}
  text-decoration: none;
  color: currentColor;

  &:hover {
    color: var(--color-text-dark);
  }

  ${focusStyleDark};
`;

export const StyledText = styled.span`
  ${copyBaseStyles}
  ${copySizes.s}
  color: var(--color-text-dark);
`;

export const StyledIcon = styled(Arrow)`
  width: var(--icon-size-xxs);
  height: var(--icon-size-xxs);
`;
